module.exports = __webpack_public_path__ + "img/picture_wuhan.172e6dba.jpg";